module.exports = __webpack_public_path__ + "img/universal-logo.b4db7fc5.png";